"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useLoginSelector = void 0;

var _index = require("../index");

/**
 * Returns the login data
 */
var useLoginSelector = function useLoginSelector() {
  return (0, _index.useShallowEqualSelector)(function (_ref) {
    var _ref$login = _ref.login,
        authEmail = _ref$login.authEmail,
        loggedIn = _ref$login.loggedIn,
        claims = _ref$login.claims,
        orgIds = _ref$login.orgIds,
        loggingIn = _ref$login.loggingIn,
        remainingSearches = _ref$login.remainingSearches,
        showRateLimitMessage = _ref$login.showRateLimitMessage,
        showBlacklistMessage = _ref$login.showBlacklistMessage,
        initialBlacklistMessage = _ref$login.initialBlacklistMessage,
        isBlacklisted = _ref$login.isBlacklisted,
        blockCountry = _ref$login.blockCountry,
        userIP = _ref$login.userIP;
    return {
      authEmail: authEmail,
      loggedIn: loggedIn,
      claims: claims,
      orgIds: orgIds,
      loggingIn: loggingIn,
      numOrgIds: orgIds ? orgIds.length : 0,
      remainingSearches: remainingSearches,
      showRateLimitMessage: showRateLimitMessage,
      showBlacklistMessage: showBlacklistMessage,
      initialBlacklistMessage: initialBlacklistMessage,
      isBlacklisted: isBlacklisted,
      blockCountry: blockCountry,
      userIP: userIP
    };
  });
};

exports.useLoginSelector = useLoginSelector;